const ITEMS = [
    "Worlds Worth Belonging To",
    "Persistent Online Worlds",
    "Identity Over Items",
    "Community Is The Content",
    "A City That Remembers You",
    "Built To Belong",
];

const Diamond = () => (
    <span className="mx-8 inline-block w-2 h-2 rotate-45 bg-[#A855F7]/70 shrink-0 self-center" />
);

export const Marquee = () => {
    const row = (key) => (
        <div key={key} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
                <span key={`${key}-${i}`} className="flex items-center shrink-0">
                    <span className="font-serif-accent italic text-2xl sm:text-3xl text-white/35 whitespace-nowrap">
                        {item}
                    </span>
                    <Diamond />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="editorial-marquee"
            className="relative border-y border-white/10 bg-[#0D0D12]/60 py-7 overflow-hidden"
        >
            <div className="flex w-max animate-marquee">
                {row("a")}
                {row("b")}
            </div>
        </div>
    );
};
